export default __webpack_public_path__ + "static/media/TopSchedule.b352fba2.JPEG";